"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconColorThemes = void 0;
var react_1 = __importStar(require("react"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var IconColorThemes;
(function (IconColorThemes) {
    IconColorThemes["uiDark1"] = "uiDark1";
    IconColorThemes["default"] = "default";
    IconColorThemes["white"] = "white";
})(IconColorThemes = exports.IconColorThemes || (exports.IconColorThemes = {}));
var Heart = function (_a) {
    var _b = _a.color, color = _b === void 0 ? IconColorThemes.default : _b, size = _a.size, rest = __rest(_a, ["color", "size"]);
    var _c = (0, react_1.useState)(b2c_theme_1.colors.defaultIconColor), iconColor = _c[0], setIconColor = _c[1];
    var _d = (0, react_1.useState)(b2c_theme_1.defaultIconSize), iconSize = _d[0], setIconSize = _d[1];
    (0, react_1.useEffect)(function () {
        switch (color) {
            case IconColorThemes.white:
                setIconColor(b2c_theme_1.colors.white);
                break;
            case IconColorThemes.uiDark1:
                setIconColor(b2c_theme_1.colors.iconUiDark1);
                break;
            default:
                setIconColor(b2c_theme_1.colors.defaultIconColor);
        }
    }, [color]);
    (0, react_1.useEffect)(function () {
        switch (size) {
            case b2c_theme_1.IconSizes.xSmall:
                setIconSize(b2c_theme_1.IconSizesPx.xSmall);
                break;
            case b2c_theme_1.IconSizes.small:
                setIconSize(b2c_theme_1.IconSizesPx.small);
                break;
            case b2c_theme_1.IconSizes.medium:
                setIconSize(b2c_theme_1.IconSizesPx.medium);
                break;
            case b2c_theme_1.IconSizes.large:
                setIconSize(b2c_theme_1.IconSizesPx.large);
                break;
            case b2c_theme_1.IconSizes.default:
                setIconSize(b2c_theme_1.defaultIconSize);
            default:
                setIconSize(b2c_theme_1.defaultIconSize);
        }
    }, [size]);
    var innerIcon = (0, react_1.useMemo)(function () {
        switch (iconSize) {
            case b2c_theme_1.IconSizesPx.xSmall:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_1030)" },
                        react_1.default.createElement("path", { "data-testid": "heart-icon", d: "M11.0449 2.01098C10.7332 1.69106 10.3606 1.43679 9.94911 1.26318C9.53761 1.08957 9.09549 1.00012 8.64886 1.00012C8.20223 1.00012 7.76011 1.08957 7.34861 1.26318C6.9371 1.43679 6.56452 1.69106 6.25286 2.01098C6.17786 2.08598 6.10286 2.23598 6.02786 2.31098C5.95286 2.23698 5.87786 2.08698 5.80286 2.01098C5.4912 1.69106 5.11863 1.43679 4.70712 1.26318C4.29561 1.08957 3.85349 1.00012 3.40686 1.00012C2.96023 1.00012 2.51811 1.08957 2.1066 1.26318C1.6951 1.43679 1.32252 1.69106 1.01086 2.01098C0.690939 2.32264 0.436673 2.69522 0.263059 3.10673C0.089445 3.51824 0 3.96035 0 4.40698C0 4.85362 0.089445 5.29573 0.263059 5.70724C0.436673 6.11875 0.690939 6.49132 1.01086 6.80298L6.02786 11.521L11.0449 6.79998C11.657 6.15301 11.9981 5.29616 11.9981 4.40548C11.9981 3.51481 11.657 2.65796 11.0449 2.01098Z", fill: iconColor })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_1030" },
                            react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.small:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_991)" },
                        react_1.default.createElement("path", { "data-testid": "heart-icon", d: "M12.3749 2.25002C11.7343 2.24826 11.101 2.3852 10.5184 2.65145C9.93579 2.9177 9.41775 3.30693 8.99987 3.7924C8.58199 3.30693 8.06395 2.9177 7.48135 2.65145C6.89876 2.3852 6.26542 2.24826 5.62487 2.25002C4.74129 2.25139 3.87766 2.51285 3.14169 3.0018C2.40572 3.49074 1.82998 4.18554 1.48626 4.99953C1.14255 5.81352 1.04608 6.71069 1.20888 7.57914C1.37168 8.4476 1.78655 9.24891 2.40175 9.88315L8.59825 16.2158C8.65061 16.2692 8.7131 16.3116 8.78206 16.3406C8.85102 16.3696 8.92507 16.3845 8.99987 16.3845C9.07494 16.3845 9.14925 16.3695 9.21842 16.3403C9.28759 16.3111 9.35022 16.2684 9.40262 16.2146L15.382 10.0789C16.0597 9.4721 16.5369 8.67365 16.7504 7.78941C16.9638 6.90518 16.9035 5.97695 16.5773 5.1278C16.2512 4.27865 15.6746 3.5487 14.9241 3.03475C14.1735 2.5208 13.2845 2.24713 12.3749 2.25002Z", fill: iconColor })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_991" },
                            react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.medium:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_946)" },
                        react_1.default.createElement("path", { "data-testid": "heart-icon", d: "M16.7221 2.00002C15.8256 1.99786 14.9392 2.19001 14.124 2.56323C13.3089 2.93646 12.5843 3.48191 12.0001 4.16202C11.416 3.48191 10.6913 2.93646 9.87618 2.56323C9.06102 2.19001 8.17466 1.99786 7.27811 2.00002C6.05125 1.99725 4.85059 2.35483 3.82514 3.02836C2.79969 3.7019 1.9946 4.66174 1.5098 5.78875C1.025 6.91576 0.881829 8.16034 1.09806 9.36799C1.31428 10.5757 1.88039 11.6932 2.72611 12.582L11.2791 21.471C11.3724 21.5681 11.4844 21.6454 11.6083 21.6981C11.7322 21.7509 11.8655 21.7781 12.0001 21.7781C12.1348 21.7781 12.2681 21.7509 12.3919 21.6981C12.5158 21.6454 12.6278 21.5681 12.7211 21.471L21.2741 12.582L21.2811 12.575C22.1249 11.6855 22.6891 10.5679 22.9038 9.36078C23.1185 8.15365 22.9742 6.91005 22.4888 5.78415C22.0034 4.65826 21.1983 3.69955 20.1732 3.02689C19.1481 2.35423 17.9482 1.99719 16.7221 2.00002Z", fill: iconColor })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_946" },
                            react_1.default.createElement("rect", { width: "24", height: "24", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.large:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_102_474)" },
                        react_1.default.createElement("path", { "data-testid": "heart-icon", d: "M54.74 31.611L32.5 54.722L10.26 31.611C8.90078 30.1788 7.86751 28.4696 7.23107 26.6005C6.59464 24.7314 6.37009 22.7468 6.57285 20.7827C6.77561 18.8187 7.40088 16.9218 8.40574 15.2222C9.4106 13.5225 10.7713 12.0604 12.3944 10.9361C14.0175 9.81183 15.8646 9.052 17.809 8.70877C19.7534 8.36554 21.7491 8.44703 23.659 8.94764C25.569 9.44826 27.348 10.3561 28.874 11.609C30.4001 12.8619 31.637 14.4301 32.5 16.206C33.3629 14.4301 34.5998 12.8619 36.1259 11.609C37.6519 10.3561 39.431 9.44826 41.3409 8.94764C43.2509 8.44703 45.2465 8.36554 47.1909 8.70877C49.1353 9.052 50.9824 9.81183 52.6056 10.9361C54.2287 12.0604 55.5893 13.5225 56.5942 15.2222C57.5991 16.9218 58.2243 18.8187 58.4271 20.7827C58.6298 22.7468 58.4053 24.7314 57.7689 26.6005C57.1324 28.4696 56.0992 30.1788 54.74 31.611Z", fill: iconColor, stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_102_474" },
                            react_1.default.createElement("rect", { width: "64", height: "64", fill: "transparent" })))));
        }
    }, [iconSize, iconColor]);
    return (react_1.default.createElement("svg", __assign({ width: iconSize, height: iconSize, viewBox: "0 0 ".concat(iconSize, " ").concat(iconSize), fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "heart-icon-container" }, rest), innerIcon));
};
exports.default = Heart;
//# sourceMappingURL=Heart.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/@urbanmassage/component-library/lib/Icons/Heart/Heart.js
// module id = 504
// module chunks = 81